"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTrustTokens = exports.clearDataForOrigin = exports.getUsageAndQuota = void 0;
var each_1 = __importDefault(require("licia/each"));
var rmCookie_1 = __importDefault(require("licia/rmCookie"));
var safeStorage_1 = __importDefault(require("licia/safeStorage"));
var Network_1 = require("./Network");
var localStore = safeStorage_1.default('local');
var sessionStore = safeStorage_1.default('session');
function getUsageAndQuota() {
    return {
        quota: 0,
        usage: 0,
        usageBreakdown: [],
    };
}
exports.getUsageAndQuota = getUsageAndQuota;
function clearDataForOrigin(params) {
    var storageTypes = params.storageTypes.split(',');
    each_1.default(storageTypes, function (type) {
        if (type === 'cookies') {
            var cookies = Network_1.getCookies().cookies;
            each_1.default(cookies, function (_a) {
                var name = _a.name;
                return rmCookie_1.default(name);
            });
        }
        else if (type === 'local_storage') {
            localStore.clear();
            sessionStore.clear();
        }
    });
}
exports.clearDataForOrigin = clearDataForOrigin;
function getTrustTokens() {
    return {
        tokens: [],
    };
}
exports.getTrustTokens = getTrustTokens;
